import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

import formatters from '../../../../../intl/formatters';

const OrdersRejectedWrapper = ({ storeName, insufficientInventorySKUs }) => {
  return (
    <FormattedMessage
      defaultMessage='Order rejected for <b>{storeName}</b>. Insufficient inventory for SKUs: <b>{insufficientInventorySKUs}</b>'
      description='rejectedOrdersAlert.alertMessage'
      id='kvaYyd'
      values={{
        b: formatters.b,
        insufficientInventorySKUs,
        storeName,
      }}
    />
  );
};

OrdersRejectedWrapper.propTypes = {
  storeName: PropTypes.string.isRequired,
  insufficientInventorySKUs: PropTypes.string.isRequired,
};

export const OrdersRejected = injectIntl(OrdersRejectedWrapper);
